module.exports = "<header class=\"raul-header\">\n  <div class=\"raul-header-logo\">\n    <a [href]=linkHref>\n      <img [src]=\"rpLogo\" class=\"rp-logo\" alt=\"Realpage | Outperform\">\n    </a>\n  </div>\n</header>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/layout/navbar.component.html
// module id = ./src/app/shared/components/layout/navbar.component.html
// module chunks = main